import { useState, useCallback } from 'react';
import { c212Api } from '../../../services/c212Api';

export function useC212Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await c212Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fc210_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index (BR-F04: skip soft-deleted) */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
